import React from 'react'
import * as C from "../componentsM/index";

const JobVacancies = () => {
    return (
        <>

            <C.Hero title={"JOB VACANCIES"} image={"/hero/GETTING.jpg"} />

            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>

                </div>


            </section>

        </>
    )
}

export default JobVacancies